import React from "react";
import { Component } from "react";
import "../scss/general.css";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory
 /*{
 // PaginationProvider,
//  SizePerPageDropdownStandalone,
//  PaginationListStandalone
}*/ from "react-bootstrap-table2-paginator";
//import paginationFactory from "react-bootstrap-table2-paginator";
import ModalError from "./ModalError";
import logo from "./images/loading.gif";
import Cookies from "universal-cookie";
import QRCode from "react-qr-code";
import VCQRcode from "./VCQRcode";
//import ModalPWD from './passwordCHG';

const axios = require("axios");
const cookies=new Cookies();

const pagination = paginationFactory({
    page: 2,
    sizePerPage: 12,
    lastPageText: '>>',
    firstPageText: '<<',
    nextPageText: '>',
    prePageText: '<',
    showTotal: false,
    alwaysShowAllBtns: true,
    modal:"",
    onPageChange: function (page, sizePerPage) {
    },
    onSizePerPageChange: function (page, sizePerPage) {
    }
  });
  const { SearchBar, ClearSearchButton } = Search;
export default class Contacts extends Component {
  constructor(props){
    super(props);
    this.state={
      products:[],
      columns:"",
      isloaded:false,
      isvalid:false,
      empimage:config.Appdir+"/images/NoImage.png",
      defaultSorted :[{dataField: 'location',order: 'asc'}],
      ErrMsg:<img src={logo} alt=""/>
    }
    //  this.handlerimage = this.handlerimage.bind(this);
    this.imageFormatter = this.imageFormatter.bind(this);
    this.QrCode = this.QrCode.bind(this);
    this.GenQrCode = this.GenQrCode.bind(this);
    }
    imageFormatter(cell,row,rowIndex)
    {
/*      let cdir=cookies.get("phpclass");
      this.setState({ logo2: cdir.substr(0,cdir.length-4)+'/images/' + cookies.get('LoginID') + '.jpg?ver=' + rn});
let imgfile = cdir.substr(0,cdir.length-4)+"/images/"+id+".jpg?ver="+rn;
this.setState({imagefile:imgfile});
*/
          return (<img style={{width:38, height:40, marginLeft:1 }} src={cell}  onError={({ currentTarget }) => {
          currentTarget.onerror = null; currentTarget.src=config.Appdir+"/images/Noimage.png";
        }} alt="" />)
  
    }
    resetmodal=()=>
    {
      this.setState({isvalid:false,modal:''});
    }
    GenQrCode=(Code)=>{
      let items=this.state.products;
      var data = items.filter(item => item.Emp_id === Code)
      this.setState({isvalid:true, modal:<VCQRcode resetmodal={this.resetmodal} Code={Code}
                    name={data[0].name} designation={data[0].designation} department={data[0].department} location={data[0].location}
                    email={data[0].email} phone={data[0].phone} pemail={data[0].pemail} pmobile={data[0].pmobile} image={data[0].image}/>});
      
    }
    QrCode(cell)
    {
    return (
        <a onClick={(e) => {

          e.preventDefault(); 
          this.GenQrCode(cell)
      }}
     href="#"><QRCode title=""  value={cell}  size="35"/>
    </a>);
  }
  
  componentDidMount(){
    document.body.style.cursor="wait";
    axios({
      method:"post",
      url: cookies.get("phpclass")+"/index.php/user/GetContact",
      headers: {'Content-Type': 'multipart/form-data'}
    })
    .then ((response)=>{
      document.body.style.cursor="default";
      this.setState({      
      isloaded:true,
      products:response.data,
      columns: [{dataField:'image', text:'',sort:false,headerStyle: () => {return { width: '40px', paddingLeft:'5px' };},formatter:this.imageFormatter},{dataField:'name', text:'Name', sort:true,headerStyle: () => {return { width: '20%' };}},{dataField:'designation', text:'Designation', sort:false,headerStyle: () => {return { width: '20%' };}},{dataField:'phone',text:'Office Phone#',  sort:false,headerStyle: () => {return { width: '10%' };}},{dataField:'pmobile',text:'Personal Phone#', sort:false,headerStyle: () => {return { width: '10%' };}},{dataField:'email',text:'Email', sort:false,headerStyle: () => {return { width: '20%' };}},{dataField:'location',text:'Location', sort:false,headerStyle: () => {return { width: '10%' }}},{dataField:'Emp_id',text:'Code', sort:false,headerStyle: () => {return {width: '40px'}}, formatter:this.QrCode}]
      });

       })
       .catch((response)=>{
        document.body.style.cursor="default";
        this.setState({ErrMsg:<ModalError/>});
      }); 

    }
  render(){
    let isvalid=this.state.isvalid;
    let isloaded=this.state.isloaded;

    if(isloaded)
    {
{/*}      if(isvalid)
          {return(<div>{this.state.modal}</div>)}
      else
    {    */}
      return (
        <div className="container1" >
        {isvalid ? this.state.modal  : ''}         
        <div style={{marginTop:"10px",float:"right"}}>
        </div>
        <ToolkitProvider
         bootstrap4
          keyField='name'
          data={this.state.products}
          columns={this.state.columns}
          search
          >       
          {
            props => (
            <div className="container2">
              <SearchBar  {...props.searchProps} style={{fontSize:11}} />
              <ClearSearchButton className="btn-secondary"  {...props.searchProps} /> 
                
                  <BootstrapTable
                    bootstrap4
                    defaultSorted={this.state.defaultSorted}
                    pagination={paginationFactory({})}
                    {...props.baseProps}
                 />
            </div>
           )
          }
        </ToolkitProvider>     
        </div>   

    );
   {/*} }     */}
    }
    else 
    { 
      return(
      <div className="container1">
            <div className="center">
            {this.state.ErrMsg}
          </div>
      </div>
      );
    }

  }  
 }
